// extracted by mini-css-extract-plugin
export default {"container":"FormInput_container__3zcaL","inputLabel":"FormInput_inputLabel__m4jo5"};